/*
 * Tenisz karkotok kozotti valtas, a kivalasztott fem es hossz megorzesevel.
 * Keszitette: Akos | branch: dev/akos | 2026-09-29
 * Modositva: Akos | branch: dev/akos | 2026-10-07 - Kiemelt karatvalaszto magyarazatanak hozzaferheto kapcsolasa.
 */
if (!customElements.get('related-bracelet-selector')) {
  customElements.define('related-bracelet-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        this.picker = document.getElementById(`ProductSelector-${this.dataset.sectionId}`);
        this.picker?.addEventListener('change', this.onVariantChange);
        return;
      }
      const source = this.querySelector('script[type="application/json"]');
      if (!source) return;
      try {
        this.products = [...new Map(JSON.parse(source.textContent)
          .filter(product => product.shape && Number(product.carat) > 0)
          .map(product => [product.id, { ...product, carat: Number(product.carat) }])).values()];
      } catch {
        return;
      }
      this.current = this.products.find(product => product.id === this.dataset.currentProduct);
      if (!this.current || this.products.length < 2) return;
      this.shape = this.querySelector('[data-related-shape]');
      this.carat = this.querySelector('[data-related-carat]');
      this.message = this.querySelector('[data-unavailable-message]');
      this.picker = document.getElementById(`ProductSelector-${this.dataset.sectionId}`);
      this.shape.replaceChildren(...[...new Set(this.products.map(product => product.shape))].sort()
        .map(value => new Option(value, value, false, value === this.current.shape)));
      this.fillCarats(this.current.shape, this.current.carat);
      this.shape.addEventListener('change', () => {
        this.message.hidden = true;
        const selectedCarat = Number(this.carat.value);
        const target = this.find(this.shape.value, selectedCarat);
        this.fillCarats(this.shape.value, target ? selectedCarat : null);
        if (target) this.navigate(target);
      });
      this.carat.addEventListener('change', () => {
        const target = this.find(this.shape.value, Number(this.carat.value));
        if (target) this.navigate(target);
      });
      this.onVariantChange = event => {
        if (event.target.name !== 'id' || !this.picker?.contains(event.target)) return;
        this.message.hidden = true;
        this.fillCarats(this.shape.value, this.carat.value ? Number(this.carat.value) : null);
      };
      this.picker?.addEventListener('change', this.onVariantChange);
      this.initialized = true;
      this.hidden = false;
      this.refreshDropdowns();
    }

    disconnectedCallback() {
      this.picker?.removeEventListener('change', this.onVariantChange);
    }

    find(shape, carat) {
      return this.products.find(product => product.shape === shape && product.carat === carat);
    }

    selectedVariant() {
      const id = this.picker?.querySelector('[name="id"]')?.value
        || new URL(location.href).searchParams.get('variant') || this.dataset.currentVariant;
      return this.current.variants.find(variant => variant.id === id);
    }

    normalize(value) {
      return value.toLowerCase().normalize('NFKC')
        .replace(/white gold/g, 'fehérarany').replace(/yellow gold/g, 'sárgaarany')
        .replace(/rose gold/g, 'rozéarany').replace(/\s+/g, '');
    }

    matchingVariant(target) {
      const selected = this.selectedVariant();
      if (!selected?.metal || !selected.length) return null;
      const matches = target.variants.filter(variant =>
        this.normalize(variant.metal) === this.normalize(selected.metal)
        && this.normalize(variant.length) === this.normalize(selected.length));
      return matches.find(variant => variant.available) || matches[0] || null;
    }

    fillCarats(shape, selected) {
      const targets = this.products.filter(product => product.shape === shape)
        .sort((a, b) => a.carat - b.carat);
      const options = targets.map(product => {
        const option = new Option(`${String(product.carat).replace('.', ',')}ct`,
          String(product.carat), false, product.carat === selected);
        option.disabled = !this.matchingVariant(product);
        return option;
      });
      if (!targets.some(product => product.carat === selected)) {
        const placeholder = new Option(this.dataset.caratPlaceholder, '', false, true);
        placeholder.disabled = true;
        options.unshift(placeholder);
      }
      this.carat.replaceChildren(...options);
      this.message.hidden = targets.some(product => this.matchingVariant(product));
      this.refreshDropdowns();
    }

    refreshDropdowns() {
      customElements.whenDefined('dropdown-input').then(() => {
        if (!this.isConnected) return;
        for (const select of [this.shape, this.carat]) {
          const dropdown = select.closest('dropdown-input');
          dropdown.update();
          dropdown.querySelector('summary')?.setAttribute('aria-label', select.getAttribute('aria-label'));
          const description = select.getAttribute('aria-describedby');
          if (description) dropdown.querySelector('summary')?.setAttribute('aria-describedby', description);
        }
      });
    }

    navigate(target) {
      if (this.navigating || target.id === this.current.id) return;
      const variant = this.matchingVariant(target);
      if (!variant) {
        this.message.hidden = false;
        return;
      }
      const url = new URL(target.url, location.origin);
      if (url.origin !== location.origin) return;
      url.searchParams.set('variant', variant.id);
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      this.navigating = true;
      location.assign(url.href);
    }
  });
}
